export function Footer(): JSX.Element {
  return <footer></footer>;
}
